export const SMARTY_VAT_CURRENT = '760 7292 22'
export const SMARTY_VAT = 'GB 569 9532 77'

export const getSmartyVAT = (isNewVAT: boolean) => {
  return isNewVAT ? SMARTY_VAT : SMARTY_VAT_CURRENT
}
